module.exports = __webpack_public_path__ + "img/hr-cargo-wagon-shadow-4.6fae40ce.png";